import { DateDisplay, FormattedText } from '../../../components';
import { DATE_PRESETS } from '../../../helper';
import styles from './logBook.module.css';

export interface LogBookProps<T extends LogEntryModel> {
  logs?: T[];
  /** Shows the entry time next to its date. */
  showTime?: boolean;
}

// Same zone as the DATETIME preset, so the date matches the timed variant.
const DATE_ONLY_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_PRESETS.MEDIUM,
  timeZone: DATE_PRESETS.DATETIME.timeZone,
};

export interface LogEntryModel {
  id: string;
  date: Date | null;
  content: string;
}

export function LogBook<T extends LogEntryModel>({
  logs = [],
  showTime = true,
}: LogBookProps<T>) {
  return (
    <table className="poem-table">
      <tbody>
        {logs?.map((entry) => (
          <tr key={entry.id}>
            <th scope="row" className={styles.headerCell}>
              <DateDisplay
                date={entry.date}
                locale="de-DE"
                options={showTime ? DATE_PRESETS.DATETIME : DATE_ONLY_OPTIONS}
              />
            </th>
            <td>
              <FormattedText value={entry.content} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
